/**
 * Engagement Tracker — Mede tempo ativo na página e reporta ao backend.
 * Invisível para o cliente. Usa Page Visibility API + sendBeacon.
 */
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function generateSessionId() {
  return 'ses_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
}

function getVisitNumber(quotationId) {
  const key = `engagement_visits_${quotationId}`;
  const current = parseInt(localStorage.getItem(key) || '0', 10);
  const next = current + 1;
  localStorage.setItem(key, String(next));
  return next;
}

/**
 * Inicia tracking de uma cotação.
 * @param {string} quotationId
 * @returns {function} cleanup
 */
export function startTracking(quotationId) {
  if (!quotationId) return () => {};

  const sessionId = generateSessionId();
  const visitNumber = getVisitNumber(quotationId);
  let activeSeconds = 0;
  let isActive = true;
  let closed = false;

  // Registrar abertura
  fetch(`${API_URL}/engagement/track`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      quotation_id: quotationId,
      session_id: sessionId,
      visit_number: visitNumber,
      user_agent: navigator.userAgent,
      referrer: document.referrer || 'direct'
    })
  }).catch(() => {});

  // Contador de tempo ativo
  const intervalId = setInterval(() => {
    if (isActive) activeSeconds += 1;
  }, 1000);

  function handleVisibility() {
    isActive = !document.hidden;
  }
  document.addEventListener('visibilitychange', handleVisibility);

  function sendClose() {
    if (closed) return;
    closed = true;
    const payload = JSON.stringify({ session_id: sessionId, duration_seconds: activeSeconds });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API_URL}/engagement/close`, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(`${API_URL}/engagement/close`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: payload, keepalive: true
      }).catch(() => {});
    }
  }

  window.addEventListener('beforeunload', sendClose);
  window.addEventListener('pagehide', sendClose);

  return function cleanup() {
    sendClose();
    clearInterval(intervalId);
    document.removeEventListener('visibilitychange', handleVisibility);
    window.removeEventListener('beforeunload', sendClose);
    window.removeEventListener('pagehide', sendClose);
  };
}
